<template>
  <div style="height: 100%;">
    <div class="closeWrelative">
      <v-btn @click="close" icon x-small>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="recoverPasswordContainer">
      <div class="d-flex justify-center flex-column mt-10">
        <p class="title_recover_password">Recuperar Contraseña</p>
        <p class="subtitle_recover_password">
          Ingresa tu correo electrónico para reestablecer tu contraseña
        </p>
      </div>
      <div class="d-flex justify-center flex-column">
        <div class="d-flex justify-center classContainerBtn">
          <div class="w-100">
            <p class="p13">Correo electrónico</p>
            <ValidationProvider
              name="email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <v-text-field
                v-model="email"
                class="mt-3"
                outlined
                label="Email"
                type="email"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </div>
        </div>
        <v-btn
          depressed
          class="white--text font-light py-5 text-capitalize mt-5"
          rounded
          color="#101820"
          :loading="loading"
          @click="HandlerSendEmail"
        >
          Enviar Código
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      email: "",
      subdomain: "",
    };
  },
  created() {
    this.subdomain = window.location.hostname.split('.')[0];
  },
  methods: {
    close() {
      this.$emit("dialog:change", false);
    },
    async HandlerSendEmail() {
      try {
        this.loading = true;
        const request = {
          subdomain: this.subdomain,
          email: this.email,
        };

        await this.$store.dispatch("auth/FORGOT_PASSWORD_EMAIL", request);

        this.$snotify.success(
          "Se ha enviado un código de recuperación a tu correo electrónico",
          "¡Éxito!"
        );
        this.$emit("dialog:change", false);
      } catch (error) {
        console.log("error", error.response);
        this.$snotify.error("Ha ocurrido un error con tu solicitud", "¡Error!");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.recoverPasswordContainer {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.closeWrelative {
  position: absolute;
  top: 0;
  margin: 3rem;
  right: 0;
}
.classContainerBtn {
  margin-bottom: 0rem;
}
.subtitle_recover_password {
  text-align: center;
  font-family: "Poppins";
  font: normal normal 300 13px/20px Poppins;
  letter-spacing: 0px;
  color: #6f7b87;
  margin-bottom: 4rem !important;
}
.title_recover_password {
  font-family: "Poppins", serif;
  font-size: 28px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.p13 {
  font-size: 13px;
  margin-bottom: 5px !important;
}
.w-100 {
  width: 100%;
}
</style> 